// extracted by mini-css-extract-plugin
export default {"page":"finance-withdrawal-list_page__9Rg3x","grid":"finance-withdrawal-list_grid__hWr96","total":"finance-withdrawal-list_total__NY6Wd"};